import React from "react";

import { Value } from "lib/build/schema";

import { api } from "src/common/utils/api";
import {
	useCreateGenericError,
	useCreateMessage
} from "src/features/notifications";
import { messages } from "src/views/forgotten-password/messages";

export function useRequestPassword(
	value: Value,
	isValid: boolean
): { isSubmitted: boolean; isLoading: boolean; onSubmit(): void } {
	const createMessage = useCreateMessage();
	const createGenericError = useCreateGenericError();

	const [isSubmitted, setSubmitted] = React.useState(false);
	const [isLoading, setLoading] = React.useState(false);

	const valueRef = React.useRef(value);
	React.useEffect(() => {
		valueRef.current = value;
	});

	const isValidRef = React.useRef(isValid);
	React.useEffect(() => {
		isValidRef.current = isValid;
	});

	const requestPassword = React.useCallback(
		async ({ email }: { email: string }) => {
			setLoading(true);
			try {
				await api.post("/authflow/forgotpassword", { email });
				createMessage(messages.success);
			} catch {
				createGenericError();
			}
			setLoading(false);
		},
		[createMessage, createGenericError]
	);

	const onSubmit = React.useCallback((): void => {
		setSubmitted(true);
		if (isValidRef.current) {
			requestPassword(valueRef.current);
		}
	}, [requestPassword]);

	return { isSubmitted, isLoading, onSubmit };
}
